"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _corner = _interopRequireDefault(require("./corner.js"));
var _side = _interopRequireDefault(require("./side.js"));
var _SpriteWrapper = _interopRequireDefault(require("../../SpriteWrapper"));
var _thumbnail = _interopRequireDefault(require("./thumbnail.png"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* eslint-disable global-require */
var _default = exports["default"] = {
  Corner: function Corner(props) {
    return /*#__PURE__*/_react["default"].createElement(_SpriteWrapper["default"], _extends({}, props, {
      spriteProps: {
        spriteClass: _style["default"].cornerSprite,
        width: 291,
        height: 286,
        zoe: _corner["default"]
      },
      talkAnimation: "speech loop",
      idleAnimation: "still"
    }));
  },
  Middle: function Middle(props) {
    return /*#__PURE__*/_react["default"].createElement(_SpriteWrapper["default"], _extends({}, props, {
      spriteProps: {
        spriteClass: _style["default"].middleSprite,
        width: 576,
        height: 673,
        zoe: _side["default"]
      },
      talkAnimation: "talk loop",
      idleAnimation: "stand idle"
    }));
  },
  Side: function Side(props) {
    return /*#__PURE__*/_react["default"].createElement(_SpriteWrapper["default"], _extends({}, props, {
      spriteProps: {
        spriteClass: _style["default"].sideSprite,
        width: 576,
        height: 673,
        zoe: _side["default"]
      },
      talkAnimation: "talk loop",
      idleAnimation: "stand idle"
    }));
  },
  assets: [require('./cornerSprite.png'), require('./sideSprite.png')],
  thumbnail: _thumbnail["default"]
};